import { supabase } from './supabaseClient';
import { ContratoItem, ContratoInput } from './types';

export const getContratos = async (obraId: number): Promise<ContratoItem[]> => {
    const { data, error } = await supabase.rpc('get_contratos', {
        p_obra_id: obraId
    });

    if (error) throw error;
    return data;
};

export const upsertContrato = async (input: ContratoInput) => {
    const { data, error } = await supabase.rpc('upsert_contrato', {
        p_id: input.id || null,
        p_obra_id: input.obra_id,
        p_fornecedor_id: input.fornecedor_id,
        p_descricao: input.descricao,
        p_valor_total: input.valor_total,
        p_data_inicio: input.data_inicio || null,
        p_data_fim: input.data_fim || null,
        p_status: input.status,
        p_arquivo_url: input.arquivo_url || null
    });

    if (error) throw error;
    return data;
};
